import type { FeedItems } from "../../../types/content/feedItem";

import { isInjectable } from "../../../utils/typechecks";
import { InjectablePlaceholder } from "../../Injectable";
import { TeaserCluster } from "../../TeaserCluster/TeaserCluster";
import { FeedItemToTeaser } from "../utils/feedItemToTeaser";

const TopNewsLayout = ({
  data,
  isFirstFeed,
  isLoggedIn,
}: {
  data: FeedItems;
  isFirstFeed?: boolean;
  isLoggedIn?: boolean;
}) => {
  let currentNrOfClusters = 0;

  return data.map((feedItem, index) => {
    if (!feedItem) return null;

    if (isInjectable(feedItem)) {
      return (
        <InjectablePlaceholder
          resource={feedItem}
          feedLayoutType="top"
          key={`${feedItem.type}${index}`}
        />
      );
    }

    const teaserWeight = feedItem.weight;

    currentNrOfClusters++;
    const isSmallCluster = feedItem.type === "Single";
    const isBox = feedItem.type === "Box";

    return (
      <TeaserCluster
        style={feedItem.style}
        header={feedItem.header}
        footer={feedItem.footer}
        key={`${feedItem.id}${index}`}
        isSmallCluster={isSmallCluster}
        isBox={isBox}
        teaserWeightValue={teaserWeight}
        isLoggedIn={isLoggedIn}
        articleId={
          feedItem.style === "native" && isSmallCluster
            ? feedItem.article.article_id
            : undefined
        }
      >
        <FeedItemToTeaser
          feedItem={feedItem}
          positionInFeed={index}
          currentNrOfClusters={currentNrOfClusters}
          isFirstFeed={isFirstFeed}
        />
      </TeaserCluster>
    );
  });
};

export { TopNewsLayout };
